var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIco7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.625 -406.978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.651,1.08a2.071,2.071,0,0,1,2.07,2.071v4.5a2.071,2.071,0,0,1-2.07,2.071H3.15A2.071,2.071,0,0,1,1.08,7.651v-4.5A2.071,2.071,0,0,1,3.15,1.08Zm0-1.08H3.15A3.154,3.154,0,0,0,0,3.151v4.5A3.154,3.154,0,0,0,3.15,10.8h4.5A3.154,3.154,0,0,0,10.8,7.651v-4.5A3.154,3.154,0,0,0,7.651,0",
    transform: "translate(48.625 408.436)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.477,70.525a1.035,1.035,0,0,1,1.035,1.035v2.251a1.035,1.035,0,0,1-1.035,1.035h-2.25a1.035,1.035,0,0,1-1.035-1.035V71.56a1.035,1.035,0,0,1,1.035-1.035Zm0-1.08h-2.25a2.117,2.117,0,0,0-2.115,2.115v2.251a2.117,2.117,0,0,0,2.115,2.115h2.25a2.117,2.117,0,0,0,2.115-2.115V71.56a2.117,2.117,0,0,0-2.115-2.115",
    transform: "translate(-41.347 349.792)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.477,139.969A1.035,1.035,0,0,1,116.512,141v2.251a1.035,1.035,0,0,1-1.035,1.035h-2.25a1.035,1.035,0,0,1-1.035-1.035V141a1.035,1.035,0,0,1,1.035-1.035Zm0-1.08h-2.25A2.117,2.117,0,0,0,111.111,141v2.251a2.117,2.117,0,0,0,2.115,2.115h2.25a2.117,2.117,0,0,0,2.115-2.115V141a2.117,2.117,0,0,0-2.115-2.115",
    transform: "translate(-41.347 291.15)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.477,1.08a1.035,1.035,0,0,1,1.035,1.035V4.366A1.035,1.035,0,0,1,115.477,5.4h-2.25a1.035,1.035,0,0,1-1.035-1.035V2.115a1.035,1.035,0,0,1,1.035-1.035Zm0-1.08h-2.25a2.117,2.117,0,0,0-2.115,2.115V4.366a2.117,2.117,0,0,0,2.115,2.115h2.25a2.117,2.117,0,0,0,2.115-2.115V2.115A2.117,2.117,0,0,0,115.477,0",
    transform: "translate(-41.347 408.436)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.959,18.441H66.817c-.467,0-.845-.242-.845-.54s.378-.54.845-.54H76.959c.467,0,.845.242.845.54s-.378.54-.845.54",
    transform: "translate(-7.086 393.775)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.858,40.082l-3.952-.036a2.1,2.1,0,0,1-2.1-2.1V17.9a.54.54,0,0,1,1.08,0V37.945a1.021,1.021,0,0,0,1.02,1.02L92.858,39a.54.54,0,0,1,0,1.08",
    transform: "translate(-22.8 393.774)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.095,87.886H87.561c-.417,0-.756-.242-.756-.54s.338-.54.756-.54h4.534c.417,0,.756.242.756.54s-.338.54-.756.54",
    transform: "translate(-22.252 335.132)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIco7);
export default __webpack_public_path__ + "static/media/menu_ico_7.22b34cf0ced5d44b0142bdedaa6735ec.svg";
export { ForwardRef as ReactComponent };